import { PublicProvider, PublicProviderLocation } from '../../api/Providers';

export function getProviderLocation(
  provider: Partial<Pick<PublicProvider, 'locations'>> | null,
): PublicProviderLocation | null {
  return provider?.locations?.[0] || null;
}
